import './styles.scss';

type PaginationProps = {
	postPerPage: number;
	totalRows: number;
	paginate: (page: number) => void;
	rowsQty: number;
	page: number;
	message?: string;
};

export const Pagination = ({
	postPerPage,
	totalRows,
	paginate,
	rowsQty,
	page,
	message,
}: PaginationProps) => {
	const pageNumbers = [];
	const numbersInPaginator = 5;
	let numIzq = 1;
	let numDer = numbersInPaginator;
	const step = Math.floor(numbersInPaginator / 2);
	const totalPages = Math.ceil(totalRows / postPerPage);

	if (totalPages <= numbersInPaginator) {
		numDer = totalPages;
	}

	if (page >= numbersInPaginator) {
		if (page + step <= totalPages) {
			numIzq = page - step;
			numDer = page + step - (numbersInPaginator % 2 === 0 ? 1 : 0);
		} else {
			numDer = totalPages;
			numIzq = totalPages + (numbersInPaginator % 2 === 0 ? 1 : 0) - 2 * step;
		}
	}

	for (let i = numIzq; i <= numDer; i++) {
		if (i > 0) {
			pageNumbers.push(i);
		}
	}

	let lbl0 = postPerPage * page >= totalRows ? totalRows : postPerPage * page;
	lbl0 = page === 1 ? postPerPage : lbl0;
	let lbl1 = page === 1 ? 1 : lbl0 - (postPerPage - 1);

	const lbl2 = rowsQty < postPerPage ? totalRows : lbl0;
	lbl1 =
		rowsQty < postPerPage
			? totalRows - rowsQty + (totalRows === 0 ? 0 : 1)
			: lbl1;

	return (
		<>
			<span className="dark-grey__span">
				Mostrando {lbl1} a {lbl2} de {totalRows} registros
			</span>
			{message && <span className="red__span">{message}</span>}
			<nav className="pagination">
				{/* <div className={`circle ${page === 1 ? "is-disable" : "is-active"}`}>
        <ArrowBack />
      </div> */}
				<ul>
					{pageNumbers.map((num) => (
						<li key={num}>
							<span
								onClick={() => paginate(num)}
								className={num === page ? 'is-active' : ''}
							>
								{num}
							</span>
						</li>
					))}
				</ul>
				{/* <div
        className={`circle is-reverse ${
          page === pageNumbers.length ? "is-disable" : "is-active"
        }`}
      >
        <ArrowBack />
      </div> */}
			</nav>
		</>
	);
};
